import {
  getBaseState,
  getEntityAdapterReducers,
  handleFulfilledAction,
  handleMultipleLoadingActions,
} from '@hwm/ui-lib';
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { EntityReducers } from '../../EntityReducers';
import { thunks } from './LeakThunks';
import { LeakDetailsModel, LeakTableModel } from '@models/ILeak';

const entityAdapter = createEntityAdapter<LeakDetailsModel>({});

const slice = createSlice({
  name: EntityReducers.leaks,
  initialState: {
    ...getBaseState(entityAdapter, { list: null as LeakTableModel[] }),
  },
  reducers: {
    ...getEntityAdapterReducers(entityAdapter),
  },
  extraReducers: (builder) => {
    handleMultipleLoadingActions([thunks.getAllLeaks, thunks.getLeak, thunks.createLeak, thunks.updateLeak], builder);
    handleFulfilledAction(thunks.getAllLeaks, builder, (state, payload) => {
      state.list = payload;
    });
    handleFulfilledAction(thunks.getLeak, builder, (state, payload) => {
      entityAdapter.upsertOne(state, payload);
    });
    handleFulfilledAction(thunks.createLeak, builder, () => {});
    handleFulfilledAction(thunks.updateLeak, builder, () => {});
  },
});

export const leakReducer = {
  slice,
  entityAdapter,
  thunks,
};
